export const SIM_INFO_REQUEST = "SIM_INFO_REQUEST";
export const SIM_INFO_RESULT = "SIM_INFO_RESULT";